module.exports = "/static/assets/9a7bbbbebc4b2b303d426f8a7f963298.gif";